/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const PointDownIcon = /*#__PURE__*/ createSvgIcon(
  'PointDownIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.1 18.5a1.131 1.131 0 001.123-1.255.511.511 0 01-.003-.055V11.5a.5.5 0 011 0c0 1.091.346 1.486.64 1.653.347.198.805.194 1.228.15a16.93 16.93 0 003.154-.78A1.8 1.8 0 0017.5 10.61v-4c0-.444-.003-.758-.165-1.152-.166-.406-.52-.936-1.308-1.724a.5.5 0 01-.147-.354V1.5H8.79v1.02c0 .855-.25 1.54-.767 2.11-.496.547-1.21.958-2.073 1.344L1.56 8.058c.044.126.115.27.234.401.262.288.898.67 2.49.332.42-.094 1.187-.277 1.852-.438.333-.08.64-.155.862-.21l.363-.088.12.485-.12-.485a.5.5 0 01.62.485v8.65h-.5l.496.055A1.13 1.13 0 009.1 18.5zm-2.12-1.336a2.13 2.13 0 104.24 0v-3.233c.047.032.095.063.145.09.65.372 1.403.322 1.837.276a17.94 17.94 0 003.345-.823A2.8 2.8 0 0018.5 10.59V6.591c0-.44 0-.927-.24-1.512-.224-.546-.64-1.144-1.38-1.904V1a.5.5 0 00-.5-.5H8.29a.5.5 0 00-.5.5v1.52c0 .635-.175 1.07-.508 1.438-.353.39-.912.733-1.746 1.106L.786 7.318A.5.5 0 00.5 7.77H1 .5V7.788a1.202 1.202 0 00.01.132 2.163 2.163 0 00.544 1.211c.586.646 1.644 1.02 3.44.638l.005-.001a136.68 136.68 0 002.481-.591v7.987z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default PointDownIcon;
